import { Icon } from "@iconify/react";
import searchFill from "@iconify/icons-eva/search-fill";
import trash2Fill from "@iconify/icons-eva/trash-2-fill";
import roundFilterList from "@iconify/icons-ic/round-filter-list";
// material
import { useTheme, styled } from "@mui/material/styles";
import {
  Box,
  Toolbar,
  Tooltip,
  IconButton,
  Typography,
  OutlinedInput,
  InputAdornment,
} from "@mui/material";
import FilterByMenu from "../../../common/FilterByMenu";

// ----------------------------------------------------------------------

export const RootStyle = styled(Toolbar)(({ theme }) => ({
  height: 96,
  display: "flex",
  justifyContent: "space-between",
  padding: theme.spacing(0, 1, 0, 3),
}));

export const SearchStyle = styled(OutlinedInput)(({ theme }) => ({
  width: 240,
  transition: theme.transitions.create(["box-shadow", "width"], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter,
  }),
  "&.Mui-focused": { width: 320, boxShadow: theme.customShadows.z8 },
  "& fieldset": {
    borderWidth: `1px !important`,
    borderColor: `${theme.palette.grey[500_32]} !important`,
  },
}));

// ----------------------------------------------------------------------

type UserListToolbarProps = {
  numSelected: number;
  filterName: string;
  searchPlaceholder: string;
  onFilterName: (value: string) => void;
  onFilterByChanged?: (newFilterBy: Array<string>) => void;
  showFilterBy?: boolean;
  filterableColumnNames?: Array<string>;
};

export default function UserListToolbar({
  numSelected,
  filterName,
  searchPlaceholder,
  onFilterName,
  onFilterByChanged = () => {},
  showFilterBy = false,
  filterableColumnNames = [],
}: UserListToolbarProps) {
  const theme = useTheme();
  const isLight = theme.palette.mode === "light";

  let FilterIcon = (
    <Tooltip title="Filter list">
      <IconButton>
        <Icon icon={roundFilterList} />
      </IconButton>
    </Tooltip>
  );

  if (numSelected > 0) {
    FilterIcon = (
      <Tooltip title="Delete">
        <IconButton>
          <Icon icon={trash2Fill} />
        </IconButton>
      </Tooltip>
    );
  } else if (showFilterBy) {
    FilterIcon = (
      <Tooltip title="Filter list">
        <Box>
          <FilterByMenu
            onfilterByChanged={onFilterByChanged}
            filterableColumnNames={filterableColumnNames}
          />
        </Box>
      </Tooltip>
    );
  }

  return (
    <RootStyle
      sx={{
        ...(numSelected > 0 && {
          color: isLight ? "primary.main" : "text.primary",
          bgcolor: isLight ? "primary.lighter" : "primary.dark",
        }),
      }}
    >
      {numSelected > 0 ? (
        <Typography component="div" variant="subtitle1">
          {numSelected} selected
        </Typography>
      ) : (
        <SearchStyle
          value={filterName}
          onChange={(e) => onFilterName(e.target.value)}
          placeholder={searchPlaceholder}
          startAdornment={
            <InputAdornment position="start">
              <Box
                component={Icon}
                icon={searchFill}
                sx={{ color: "text.disabled" }}
              />
            </InputAdornment>
          }
        />
      )}

      {FilterIcon}
    </RootStyle>
  );
}
